import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

import Loader from "../../components/Loader";

import { useAuth } from "../../services/wp.auth.service";
import { useNotifications } from "../../components/NotificationsContext";

const MagicLogin = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const username = searchParams.get("username");
	const redirect = searchParams.get("redirect") || "/";
	const key = searchParams.get("loginKey");
	const { login, user } = useAuth();
	const { addNotification } = useNotifications();

	useEffect(async () => {

		if (user) {
			addNotification({
				message: "You are already logged in.",
				type: "warning"
			});
			navigate("/");
			return;
		}

		if (!username || !key) {
			navigate("/login");
		} else {
			try {
				await login({
					email: username,
					magic: true,
					password: key
				});
				navigate(redirect);
			} catch (error) {
				navigate("/login", { state: {
					message: "Expired login link.",
					variant: "danger"
				} });
			}
		}
	}, []);

	return <Loader />;
};

export default MagicLogin;
